/**
 * cookie处理方法
 */
const CookieUtils = {
  /**
   * CookieUtils 工具类
   * @param cname key
   * @param cvalue value
   * @param exdays expired time , default half an hour
   */
  setCookie: function (cname, cvalue, exdays = 1 / 48) {
    let d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    // add path in case of different env gets error,add for loginToken 599900
    document.cookie = `${cname}=${cvalue};expires=${d.toUTCString()};path=/`;
  },
  getCookie: function (name) {
    if (!document.cookie || document.cookie.length <= 0) return "";
    const cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
      if (cookieArr[i] && cookieArr[i].length > 0) {
        let arr = cookieArr[i].split("=");
        if (arr[0] && arr[0].replace(/(^\s*)|(\s*$)/g, "") === name) {
          return arr[1];
        }
      }
    }
    return "";
  },
};

export default CookieUtils;
